import { render, staticRenderFns } from "./ConfirmationForm.vue?vue&type=template&id=22566fd9&"
import script from "./ConfirmationForm.vue?vue&type=script&lang=js&"
export * from "./ConfirmationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports